import { render } from "./Idiomas.vue?vue&type=template&id=768bfca4&scoped=true"
import script from "./Idiomas.vue?vue&type=script&lang=js"
export * from "./Idiomas.vue?vue&type=script&lang=js"

import "./Idiomas.vue?vue&type=style&index=0&id=768bfca4&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768bfca4"]])

export default __exports__